import { createSlice } from '@reduxjs/toolkit';

const templatesSlice = createSlice({
  name: 'templates',
  initialState: {},
  reducers: {
    addTemplateSliceAction: (state, action) => {
      const { identifier, layout } = action.payload;
      state[identifier] = layout;
    },
    updateTemplateSliceAction: (state, action) => {
      const { identifier, layout } = action.payload;
      if (state[identifier]) {
        state[identifier] = { ...state[identifier], ...layout };
      }
    },
    deleteTemplateSliceAction: (state, action) => {
      const identifier = action.payload;
      delete state[identifier];
    },
    clearTemplatesSliceAction: () => {
      return {};
    },
  },
});

export const {
  addTemplateSliceAction,
  updateTemplateSliceAction,
  deleteTemplateSliceAction,
  clearTemplatesSliceAction,
} = templatesSlice.actions;

export default templatesSlice.reducer;
